import PercentileSummary from "./PercentileSummary";
export default PercentileSummary;
